export default __webpack_public_path__ + "4ff9505d4df1f273d7f691576d7b34f7.svg";